module.exports = __webpack_public_path__ + "static/media/bell-solid.f08b0f7e.svg";